// import React from "react";
// import { Box, Typography, IconButton } from "@mui/material";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

// const PreviewTeam = ({ data, onEdit, onDelete }) => {
//   const handleCardClick = (index, e) => {
//     if (e) {
//       e.stopPropagation();
//       e.preventDefault();
//     }
//     if (onEdit) {
//       onEdit("team", index);
//     }
//   };

//   const handleDelete = (index, e) => {
//     if (e) {
//       e.stopPropagation();
//       e.preventDefault();
//     }
//     if (window.confirm("Are you sure you want to delete this team member?")) {
//       if (onDelete) {
//         onDelete("team", index);
//       }
//     }
//   };

//   return (
//     <Box onClick={(e) => e.stopPropagation()}>
//       <Typography
//         variant="caption"
//         color="text.secondary"
//         fontWeight={600}
//         display="block"
//         mb={2}
//       >
//         {data.sectionTitle}
//       </Typography>

//       {data.subheading && (
//         <Typography variant="body2" color="text.secondary" mb={2}>
//           {data.subheading}
//         </Typography>
//       )}

//       <Box display="flex" gap={2} flexWrap="wrap">
//         {data.items
//           .filter((i) => i.name)
//           .map((member, i) => (
//             <Box
//               key={i}
//               onClick={(e) => handleCardClick(i, e)}
//               sx={{
//                 flex: "0 0 180px",
//                 background: "rgba(255,255,255,0.05)",
//                 border: "1px solid rgba(255,255,255,0.1)",
//                 borderRadius: "10px",
//                 p: 2,
//                 cursor: "pointer",
//                 transition: "all 0.2s",
//                 position: "relative",
//                 "&:hover": {
//                   background: "rgba(255,255,255,0.08)",
//                   borderColor: "#3b82f6",
//                   transform: "translateY(-2px)",
//                   boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
//                 },
//               }}
//             >
//               {/* Edit Icon (top right) */}
//               <Box
//                 sx={{
//                   position: "absolute",
//                   top: 8,
//                   right: 8,
//                   display: "flex",
//                   gap: 0.5,
//                 }}
//               >
//                 <IconButton
//                   size="small"
//                   onClick={(e) => handleDelete(i, e)}
//                   sx={{
//                     width: 24,
//                     height: 24,
//                     background: "rgba(244,67,54,0.1)",
//                     color: "#f44336",
//                     "&:hover": {
//                       background: "rgba(244,67,54,0.2)",
//                     },
//                   }}
//                 >
//                   <DeleteOutlineIcon sx={{ fontSize: 14 }} />
//                 </IconButton>
//                 <IconButton
//                   size="small"
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     handleCardClick(i, e);
//                   }}
//                   sx={{
//                     width: 24,
//                     height: 24,
//                     background: "rgba(59,130,246,0.1)",
//                     color: "#3b82f6",
//                     "&:hover": {
//                       background: "rgba(59,130,246,0.2)",
//                     },
//                   }}
//                 >
//                   <EditIcon sx={{ fontSize: 14 }} />
//                 </IconButton>
//               </Box>

//               <Box display="flex" flexDirection="column" alignItems="center" gap={1}>
//                 {/* Photo */}
//                 {member.photoUrl ? (
//                   <Box
//                     component="img"
//                     src={member.photoUrl}
//                     sx={{
//                       width: 60,
//                       height: 60,
//                       borderRadius: "50%",
//                       objectFit: "cover",
//                       border: "2px solid rgba(59,130,246,0.3)",
//                     }}
//                   />
//                 ) : (
//                   <Box
//                     sx={{
//                       width: 60,
//                       height: 60,
//                       borderRadius: "50%",
//                       background: "rgba(59,130,246,0.1)",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                     }}
//                   >
//                     <Typography fontSize={24}>👤</Typography>
//                   </Box>
//                 )}

//                 {/* Name & Role */}
//                 <Box textAlign="center">
//                   <Typography variant="subtitle2" fontWeight={600} noWrap>
//                     {member.name}
//                   </Typography>
//                   {member.role && (
//                     <Typography
//                       variant="caption"
//                       color="#3b82f6"
//                       noWrap
//                       display="block"
//                     >
//                       {member.role}
//                     </Typography>
//                   )}
//                 </Box>

//                 {/* Skills (max 2) */}
//                 {member.skills?.length > 0 && (
//                   <Box display="flex" gap={0.5} flexWrap="wrap" justifyContent="center">
//                     {member.skills.slice(0, 2).map((skill, idx) => (
//                       <Box
//                         key={idx}
//                         sx={{
//                           fontSize: "9px",
//                           px: 1,
//                           py: 0.2,
//                           borderRadius: "4px",
//                           background: skill.color || "rgba(59,130,246,0.1)",
//                           color: skill.color?.includes("text-") ? "inherit" : "#3b82f6",
//                         }}
//                       >
//                         {skill.name}
//                       </Box>
//                     ))}
//                     {member.skills.length > 2 && (
//                       <Box
//                         sx={{
//                           fontSize: "9px",
//                           px: 1,
//                           py: 0.2,
//                           borderRadius: "4px",
//                           background: "rgba(255,255,255,0.1)",
//                         }}
//                       >
//                         +{member.skills.length - 2}
//                       </Box>
//                     )}
//                   </Box>
//                 )}
//               </Box>
//             </Box>
//           ))}

//         {!data.items.some((i) => i.name) && (
//           <Typography variant="caption" color="text.secondary">
//             No members added
//           </Typography>
//         )}
//       </Box>
//     </Box>
//   );
// };

// export default PreviewTeam;

import React from "react";
import {
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import SummaryCard from "../shared/SummaryCard";

const PreviewTeam = ({ data, onEdit, onDelete, onChange }) => (
  <Box onClick={(e) => e.stopPropagation()}>
    {data.sectionTitle && (
      <Typography variant="caption" color="text.secondary" fontWeight={600} display="block" mb={2}>
        {data.sectionTitle}
      </Typography>
    )}
    {data.subheading && (
      <Typography variant="body2" color="text.secondary" mb={2}>
        {data.subheading}
      </Typography>
    )}

    {/* ── Card Design Style dropdown ── */}
    <FormControl
      size="small"
      sx={{ minWidth: 220, mb: 2 }}
      onClick={(e) => e.stopPropagation()}
    >
      <InputLabel>Card Design Style</InputLabel>
      <Select
        value={data.cardStyle || "overlap"}
        label="Card Design Style"
        onChange={(e) => onChange?.({ ...data, cardStyle: e.target.value })}
        sx={{ borderRadius: "8px" }}
      >
        <MenuItem value="overlap">Overlap Style (circle avatar)</MenuItem>
        <MenuItem value="flat">Flat Style (top image)</MenuItem>
      </Select>
    </FormControl>

    <Box display="flex" gap={2} flexWrap="wrap">
      {data.items.filter((i) => i.name).length === 0 ? (
        <Typography variant="caption" color="text.secondary">No members added</Typography>
      ) : (
        data.items.filter((i) => i.name).map((member, i) => (
          <SummaryCard
            key={i}
            width={180}
            onClick={() => onEdit?.("team", i)}
            onDelete={() => onDelete?.("team", i)}
          >
            <Box display="flex" flexDirection="column" alignItems="center" gap={1}>
              {member.photoUrl ? (
                <Box
                  component="img"
                  src={member.photoUrl}
                  sx={{ width: 60, height: 60, borderRadius: "50%", objectFit: "cover", border: "2px solid rgba(59,130,246,0.3)" }}
                />
              ) : (
                <Box sx={{ width: 60, height: 60, borderRadius: "50%", background: "rgba(59,130,246,0.1)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <Typography fontSize={24}>👤</Typography>
                </Box>
              )}

              <Box textAlign="center">
                <Typography variant="subtitle2" fontWeight={600} noWrap>
                  {member.isFounder && "⭐ "}{member.name}
                </Typography>
                {member.role && (
                  <Typography variant="caption" color="#3b82f6" noWrap display="block">{member.role}</Typography>
                )}
              </Box>

              {member.skills?.length > 0 && (
                <Box display="flex" gap={0.5} flexWrap="wrap" justifyContent="center">
                  {member.skills.slice(0, 2).map((skill, idx) => (
                    <Box key={idx} sx={{ fontSize: "9px", px: 1, py: 0.2, borderRadius: "4px", background: skill.color || "rgba(59,130,246,0.1)", color: "#3b82f6" }}>
                      {skill.name}
                    </Box>
                  ))}
                  {member.skills.length > 2 && (
                    <Box sx={{ fontSize: "9px", px: 1, py: 0.2, borderRadius: "4px", background: "rgba(255,255,255,0.1)" }}>
                      +{member.skills.length - 2}
                    </Box>
                  )}
                </Box>
              )}
            </Box>
          </SummaryCard>
        ))
      )}
    </Box>
  </Box>
);

export default PreviewTeam;